// document.addEventListener("DOMContentLoaded", function () {
//   const compSection = document.querySelector(".comp-collection-grid");
//   const swiperContainer = document.querySelector(".comp-collection-grid__swiper");

//   if (!swiperContainer) return;

//   // Initialize Swiper
//   const swiper = new Swiper(swiperContainer, {
//     slidesPerView: 4,
//     spaceBetween: 0,
//     navigation:{
//       nextEl: ".ccg-arrow-next",
//       prevEl: ".ccg-arrow-prev",
//     },
//     scrollbar: {
//       el: ".swiper-scrollbar",
//       draggable: true,
//     },
//     breakpoints: {
//       1024: { slidesPerView: 4, spaceBetween: 0 },
//       768: { slidesPerView: 3, spaceBetween: 0 },
//       480: { slidesPerView: 2, spaceBetween: 0 },
//       0: { slidesPerView: 2, spaceBetween: 0 },
//     },
//   });

//   // --- Card & Submenu Logic (kept from your original code) ---
//   const cards = document.querySelectorAll(".collection-card");

//   // Initialize Submenus
//   function initSubmenus() {
//     document.querySelectorAll(".menu-item[data-has-children='true']").forEach(item => {
//       const menuTitle = item.querySelector(".menu-title").textContent;
//       const submenu = item.querySelector(".submenu");
//       if (!submenu) return;

//       const submenuHTML = submenu.innerHTML;
//       const submenuWrapper = document.createElement('div');
//       submenuWrapper.className = 'submenu';
//       submenuWrapper.innerHTML = `
//         <div class="submenu-header">
//           <button class="submenu-back">
//             <svg class="submenu-back-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//             </svg>
//             Back
//           </button>
//           <h4 class="submenu-title">${menuTitle}</h4>
//           <div style="width: 16px;"></div>
//         </div>
//         <ul class="submenu-list">${submenuHTML}</ul>
//       `;
//       const cardContent = item.closest('.collection-card__content');
//       cardContent.appendChild(submenuWrapper);
//       submenu.style.display = 'none';

//       item.addEventListener("click", (e) => {
//         e.stopPropagation();
//         openSubmenu(item, submenuWrapper);
//       });

//       submenuWrapper.querySelector('.submenu-back').addEventListener('click', (e) => {
//         e.stopPropagation();
//         closeSubmenu(item, submenuWrapper);
//       });
//     });
//   }

//   function openSubmenu(menuItem, submenu) {
//     const cardContent = menuItem.closest('.collection-card__content');
//     const mainMenu = cardContent.querySelector('.collection-card__menu');
//     mainMenu.style.opacity = '0';
//     mainMenu.style.visibility = 'hidden';
//     mainMenu.style.position = 'absolute';
//     submenu.style.display = 'block';
//     setTimeout(() => submenu.classList.add('active'), 10);
//   }

//   function closeSubmenu(menuItem, submenu) {
//     const cardContent = menuItem.closest('.collection-card__content');
//     const mainMenu = cardContent.querySelector('.collection-card__menu');
//     submenu.classList.remove('active');
//     setTimeout(() => {
//       submenu.style.display = 'none';
//       mainMenu.style.opacity = '1';
//       mainMenu.style.visibility = 'visible';
//       mainMenu.style.position = 'relative';
//     }, 300);
//   }

//   // Expand/collapse cards
//   cards.forEach(card => {
//     const bar = card.querySelector(".collection-card__bar");
//     const content = card.querySelector(".collection-card__content");
//     const barArrow = bar.querySelector(".collection-card__toggle-arrow");
//     const contentArrow = content.querySelector(".collection-card__header .collection-card__toggle-arrow");

//     const toggleCard = (show) => {
//       if (show) {
//         content.classList.add('active');
//         barArrow.classList.add('rotated');
//         contentArrow.classList.add('rotated');
//       } else {
//         content.classList.remove('active');
//         barArrow.classList.remove('rotated');
//         contentArrow.classList.remove('rotated');
//         content.querySelectorAll('.submenu.active').forEach(submenu => {
//           submenu.classList.remove('active');
//           setTimeout(() => (submenu.style.display = 'none'), 300);
//         });
//         const mainMenu = content.querySelector('.collection-card__menu');
//         if (mainMenu) {
//           mainMenu.style.opacity = '1';
//           mainMenu.style.visibility = 'visible';
//           mainMenu.style.position = 'relative';
//         }
//       }
//     };

//     bar.addEventListener("click", () => {
//       const isOpen = content.classList.contains('active');
//       document.querySelectorAll(".collection-card__content.active").forEach(c => {
//         if (c !== content) {
//           c.classList.remove('active');
//           const otherCard = c.closest('.collection-card');
//           otherCard.querySelectorAll('.collection-card__toggle-arrow').forEach(a => a.classList.remove('rotated'));
//         }
//       });
//       toggleCard(!isOpen);
//     });

//     content.querySelector(".collection-card__header").addEventListener("click", (e) => {
//       e.stopPropagation();
//       toggleCard(false);
//     });
//   });

//   document.addEventListener('click', (e) => {
//     if (!e.target.closest('.collection-card__content') && !e.target.closest('.collection-card__bar')) {
//       document.querySelectorAll(".collection-card__content.active").forEach(content => {
//         content.classList.remove('active');
//         const card = content.closest('.collection-card');
//         card.querySelectorAll('.collection-card__toggle-arrow').forEach(a => a.classList.remove('rotated'));
//       });
//     }
//   });

//   initSubmenus();
// });


document.addEventListener("DOMContentLoaded", function () {
  const compSection = document.querySelector(".comp-collection-grid");
  const swiperContainer = document.querySelector(".comp-collection-grid__swiper");

  if (!swiperContainer) return;

  // Initialize Swiper
  const swiper = new Swiper(swiperContainer, {
    slidesPerView: 4,
    spaceBetween: 0,
    navigation: {
      nextEl: ".ccg-arrow-next",
      prevEl: ".ccg-arrow-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    breakpoints: {
      1024: { slidesPerView: 4, spaceBetween: 0 },
      768: { slidesPerView: 3, spaceBetween: 0 },
      480: { slidesPerView: 2, spaceBetween: 0 },
      0: { slidesPerView: 2, spaceBetween: 0 },
    },
  });

  const cards = document.querySelectorAll(".collection-card");

  // Initialize Submenus
  function initSubmenus() {
    document.querySelectorAll(".menu-item[data-has-children='true']").forEach(item => {
      const menuTitle = item.querySelector(".menu-title").textContent;
      const submenu = item.querySelector(".submenu");
      if (!submenu) return;

      const submenuHTML = submenu.innerHTML;
      const submenuWrapper = document.createElement('div');
      submenuWrapper.className = 'submenu';
      submenuWrapper.innerHTML = `
        <div class="submenu-header">
          <button class="submenu-back">
            <svg class="submenu-back-arrow" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Back
          </button>
          <h4 class="submenu-title">${menuTitle}</h4>
          <div style="width: 16px;"></div>
        </div>
        <ul class="submenu-list">${submenuHTML}</ul>
      `;
      const cardContent = item.closest('.collection-card__content');
      cardContent.appendChild(submenuWrapper);
      submenu.style.display = 'none';

      item.addEventListener("click", (e) => {
        e.stopPropagation();
        openSubmenu(item, submenuWrapper);
      });

      submenuWrapper.querySelector('.submenu-back').addEventListener('click', (e) => {
        e.stopPropagation();
        closeSubmenu(item, submenuWrapper);
      });
    });
  }

  function openSubmenu(menuItem, submenu) {
    const cardContent = menuItem.closest('.collection-card__content');
    const mainMenu = cardContent.querySelector('.collection-card__menu');
    mainMenu.style.opacity = '0';
    mainMenu.style.visibility = 'hidden';
    mainMenu.style.position = 'absolute';
    submenu.style.display = 'block';
    setTimeout(() => submenu.classList.add('active'), 10);
  }

  function closeSubmenu(menuItem, submenu) {
    const cardContent = menuItem.closest('.collection-card__content');
    const mainMenu = cardContent.querySelector('.collection-card__menu');
    submenu.classList.remove('active');
    setTimeout(() => {
      submenu.style.display = 'none';
      mainMenu.style.opacity = '1';
      // mainMenu.style.visibility = 'hidden';
      // mainMenu.style.position = 'relative';
    }, 300);
  }

  // Expand/collapse cards
  cards.forEach(card => {
    const bar = card.querySelector(".collection-card__bar");
    const content = card.querySelector(".collection-card__content");
    const barArrow = bar.querySelector(".collection-card__toggle-arrow");
    const contentArrow = content.querySelector(".collection-card__header .collection-card__toggle-arrow");

    const toggleCard = (show) => {
      if (show) {
        content.classList.add('active');
        barArrow.classList.add('rotated');
        contentArrow.classList.add('rotated');
        bar.classList.add('bar-clicked'); // ✅ Added
      } else {
        content.classList.remove('active');
        barArrow.classList.remove('rotated');
        contentArrow.classList.remove('rotated');
        bar.classList.remove('bar-clicked'); // ✅ Removed

        content.querySelectorAll('.submenu.active').forEach(submenu => {
          submenu.classList.remove('active');
          setTimeout(() => (submenu.style.display = 'none'), 300);
        });

        const mainMenu = content.querySelector('.collection-card__menu');
        if (mainMenu) {
          mainMenu.style.opacity = '1';
          // mainMenu.style.visibility = 'visible';
          // mainMenu.style.position = 'relative';
        }
      }
    };

    bar.addEventListener("click", () => {
      const isOpen = content.classList.contains('active');

      document.querySelectorAll(".collection-card__content.active").forEach(c => {
        if (c !== content) {
          c.classList.remove('active');
          const otherCard = c.closest('.collection-card');
          otherCard.querySelectorAll('.collection-card__toggle-arrow').forEach(a => a.classList.remove('rotated'));
          otherCard.querySelector('.collection-card__bar')?.classList.remove('bar-clicked'); // ✅ Remove from others
        }
      });

      toggleCard(!isOpen);
    });

    content.querySelector(".collection-card__header").addEventListener("click", (e) => {
      e.stopPropagation();
      toggleCard(false); // ✅ Removes bar-clicked automatically
    });
  });

  // Close when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.collection-card__content') && !e.target.closest('.collection-card__bar')) {
      document.querySelectorAll(".collection-card__content.active").forEach(content => {
        content.classList.remove('active');
        const card = content.closest('.collection-card');
        card.querySelectorAll('.collection-card__toggle-arrow').forEach(a => a.classList.remove('rotated'));
        card.querySelector('.collection-card__bar')?.classList.remove('bar-clicked'); // ✅ Remove here too
      });
    }
  });

  initSubmenus();
});